/*==================================================
HERSHOP ABOUT
Premium Reveal
==================================================*/

(function () {

    "use strict";

    function initAbout(root) {

        var sections = root
            ? root.querySelectorAll(".hershop-about")
            : document.querySelectorAll(".hershop-about");

        if (!sections.length) return;

        sections.forEach(function (section) {

            if (section.dataset.hershopInit) return;

            section.dataset.hershopInit = "true";

            var features = section.querySelectorAll(".hershop-about__feature");

            features.forEach(function (feature, index) {

                feature.style.transitionDelay =
                    (0.15 + index * 0.14) + "s";

            });

            var observer = new IntersectionObserver(function (entries) {

                entries.forEach(function (entry) {

                    if (!entry.isIntersecting) return;

                    entry.target.classList.add("is-visible");

                    observer.unobserve(entry.target);

                });

            }, {

                threshold: 0.18,
                rootMargin: "0px 0px -80px 0px"

            });

            observer.observe(section);

        });

    }

    if (document.readyState === "loading") {

        document.addEventListener("DOMContentLoaded", function () {

            initAbout();

        });

    } else {

        initAbout();

    }

    document.addEventListener("shopify:section:load", function (event) {

        initAbout(event.target);

    });

})();